import request from '@/utils/request'

export const registerApi = (data) => {
  return request({
    url: '/xy/register',
    method: 'post',
    data
  })
}
export const loginApi = (data) => {
  return request({
    url: '/xy/login',
    method: 'post',
    data
  })
}